module.exports = __webpack_public_path__ + "static/media/map-pin-outlined-active.c759fd03.svg";